import { formatShareCode } from './shareCode';
var KEY = 'ownShareCode';
export function rememberOwnShareCode(code) {
    var formatted = formatShareCode(code);
    if (!formatted)
        return;
    try {
        sessionStorage.setItem(KEY, formatted);
    }
    catch (_a) {
        // sessionStorage may be unavailable (e.g. private browsing); ignore.
    }
}
export function isOwnShareCode(code) {
    var formatted = formatShareCode(code);
    if (!formatted)
        return false;
    try {
        return sessionStorage.getItem(KEY) === formatted;
    }
    catch (_a) {
        return false;
    }
}
